import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authRequired, setAuthRequired] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const response = await axios.get('/api/auth/status');
      setAuthRequired(response.data.auth_required);
      
      if (!response.data.auth_required) {
        setIsAuthenticated(true);
        setUser({ name: 'Developer' });
      } else if (response.data.authenticated) {
        setIsAuthenticated(true);
        setUser(response.data.user);
      } else {
        setIsAuthenticated(false);
        setUser(null);
      }
    } catch (err) {
      console.error('Auth check failed:', err);
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (password) => {
    const response = await axios.post('/api/auth/login', { password });
    if (response.data.success) {
      setIsAuthenticated(true);
      setUser(response.data.user);
      return true;
    }
    return false;
  };

  const logout = async () => {
    try {
      await axios.post('/api/auth/logout');
    } catch (err) {
      console.error('Logout failed:', err);
    }
    setIsAuthenticated(false);
    setUser(null);
  };

  return {
    user,
    isLoading,
    isAuthenticated,
    authRequired,
    login,
    logout,
    checkAuth,
  };
}

export default useAuth;
